import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Empty } from 'antd';
import FlatsTable from '../../../../../../components/ui/tables/FlatsTable/FlatsTable';
import useFlatsGridState from '../../../../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../../../../hooks/useHousingStockState';
import { useFlatsTableListActions } from '../../../../providers/flatsTableListProvider';
import {
  selectEntranceName,
  selectFlatsTableData,
} from '../../../../lib/storeSelectors';
import {
  FlatsTableProvider,
  useFlatsTableData,
} from './providers/tableProvider';
import { withAddAndInfo } from '../../hocs/withAddAndInfo';
import AddAndInfoButtons from '../../../../../../components/ui/AddAndInfoButtons/AddAndInfoButtons';
import { filterKeys } from './config/filter';
import { checkHasAcceptanceStatusesData } from './utils/data';

const AddAndInfoActions = withAddAndInfo({ Component: AddAndInfoButtons });

const Table = ({ hasAcceptanceStatusesData = false }) => {
  const { onTableChange } = useFlatsTableListActions();

  const { data, filters, filteredInfo, entranceName, sortedInfo } =
    useFlatsTableData();

  const { flatsGridQueryKey } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const queryKeys = useMemo(
    () => [flatsGridQueryKey, housingStockQueryKey],
    [flatsGridQueryKey, housingStockQueryKey]
  );

  const handleTableChange = useCallback(
    (_pagination, filters, sorter) => {
      onTableChange({ entranceName, filters, sorter });
    },
    [entranceName, onTableChange]
  );

  return (
    <FlatsTable
      dataSource={data}
      filteredInfo={filteredInfo}
      sortedInfo={sortedInfo}
      onChange={handleTableChange}
      AddAndInfoActions={AddAndInfoActions}
      queryKeys={queryKeys}
      typesFilter={filters[filterKeys.types]}
      stagesFilter={filters[filterKeys.stages]}
      stepsFilter={filters[filterKeys.steps]}
      acceptanceStatusesFilter={filters[filterKeys.acceptanceStatuses]}
      salesFilter={filters[filterKeys.sales]}
      hideAcceptanceStatusesCol={!hasAcceptanceStatusesData}
    />
  );
};

const Content = ({ data }) => {
  const activeEntrance = useSelector(selectEntranceName);

  const { entranceNames, hasAcceptanceStatusesData } = useMemo(
    () => ({
      entranceNames: Array.from(data.keys()),
      hasAcceptanceStatusesData: checkHasAcceptanceStatusesData(
        Array.from(data.get('Все')['Все'])
      ),
    }),
    [data]
  );

  return entranceNames.map((name) => (
    <FlatsTableProvider
      key={name}
      entranceName={name}
    >
      {name === activeEntrance ? (
        <Table hasAcceptanceStatusesData={hasAcceptanceStatusesData} />
      ) : null}
    </FlatsTableProvider>
  ));
};

const TableView = () => {
  const { data } = useSelector(selectFlatsTableData) || {};

  return data?.size ? (
    <Content data={data} />
  ) : (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  );
};

export default TableView;
